import React from 'react'
import { Grid, List, Icon, Loader, Card, Button } from 'semantic-ui-react';
import { Form } from 'formsy-semantic-ui-react';
import { dispatch } from '@rematch/core';
import Labels from './../../../../common/Labels'
import { source } from 'react-aim';

import EllipsisTooltip from '../../../../common/EllipsisTooltip';
import ImageResizer from './../../../../drive/ImageResizer/ImageResizer';
import ImageAvater from '../../../../drive/Components/ImageAvater';
import SingleLineEditText from '../../../../common/SingleLineEditText';
import MultiLineEditText from '../../../../common/MultiLineEditText';
import SetPriority from './../ActiveInitiative/SetPriority'
import { slugify } from '../../../../../helpers/slugify';

@source({
    mouseEnter: (props, component) => {
        dispatch.app.setHelpContext('Summary Card')
    }
})


class Summary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            existingInitiativeName: null,
            updatedImage: null
        }
        this.getTeam = this.getTeam.bind(this);
    }

    componentWillMount() {
        this.setState({
            existingInitiativeName: this.props.selectedDataById.name
        })
        if (!this.props.teamList || this.props.teamList.length === 0) {
            let payload = {};
            payload.id = this.props.selectedOrganisation.id;
            payload.teamlist = true;
            dispatch.initiatives.getTeamsUnderManager(payload);
        }


    }
    componentDidUpdate() {

    }
    async componentDidMount() {
        if (this.props.selectedDataById) {
            await dispatch.initiatives.getPracticeById(this.props.selectedDataById.practiceId)
        }
    }
    async componentWillReceiveProps(nextProps) {
        if (this.state.updatedImage !== nextProps.selectedDataById.picture) {
            this.setState({ updatedImage: this.props.selectedDataById.picture })
        }

    }

    openImageModal = (open) => {
        this.setState({ open: open })
    }

    cloudinaryImage = (imageData) => {
        this.setState({ loader: true })
        if (imageData && imageData.data) {
            this.setState({ updatedImage: imageData.data.secure_url, loader: false })
            dispatch.initiatives.updateInitiativeBySpecificFields({ _id: this.props.selectedDataById, picture: imageData.data.secure_url })
        }
    }

    getTeam() {
        const teamObj = this.props.teamList && this.props.teamList.filter((team) => {
            return team.value === this.props.selectedDataById.teamId._id
        })
        return teamObj ? teamObj && teamObj[0] && teamObj[0].text : '';
    }

    handleInitiativeNameChange = (data) => {
        let initiativeName = data.target.value.trim();
        if (/^[^-\s][\s\S]{1,40}$/.test(initiativeName)) {
            this.setState({
                updatedInitiativeName: initiativeName
            });
            let payload = {
                name: initiativeName,
                organizationId: this.props.selectedOrganisation.id,
                _id: this.props.selectedInitiative._id
            }
            dispatch.initiatives.searchInitiativeByName(payload)
        }
    }

    saveData = (data) => {
        if (data.name === 'Name') {
            this.props.selectedDataById.id = this.props.selectedDataById._id;
            this.props.selectedDataById.name = data.text;
            this.props.selectedDataById.slug = slugify(data.text);
            dispatch.initiatives.updateInitiativeBySpecificFields({ _id: this.props.selectedDataById._id, name: data.text, slug: slugify(data.text) })
        } else if (data.name === 'Description') {
            this.props.selectedDataById.id = this.props.selectedDataById._id;
            this.props.selectedDataById.description = data.text;
            dispatch.initiatives.updateInitiativeBySpecificFields({ _id: this.props.selectedDataById._id, description: data.text })
        }
    }

    render() {
        let customeError = this.props.initiativeError ?
            <div style={{ marginTop: '-10px' }}>
                <span style={{ color: "red", margin: '0 0 0em' }}>
                    {this.props.initiativeError}
                </span> <br />
            </div>
            : ''

        return (
            <Form noValidate
                className="formcyForm"
                ref={ref => this.form = ref}
                onValidSubmit={this.props.onSubmit}
            >
                <Grid>
                    <Grid.Row >
                        <Grid.Column width={11}>
                            <SingleLineEditText
                                name="Name"
                                text={(this.props.initiativeError ? this.state.existingInitiativeName : this.props.selectedDataById.name) || ''}
                                type="text"
                                onSaveClick={this.saveData}
                            />
                            {customeError}
                            <Grid.Row>
                                <MultiLineEditText
                                    name="Description"
                                    text={this.props.selectedDataById.description || ''}
                                    type="textarea"
                                    onSaveClick={this.saveData}
                                    htmlView={true}
                                />
                            </Grid.Row>
                            <Grid.Row style={{ margin: "0 0 15px 0" }}>
                                <SetPriority {...this.props} />
                            </Grid.Row>

                            <Grid.Row>
                                <Labels
                                    name="Category"
                                    text={<span >
                                        {this.props.selectedDataById.baseCategory && this.props.selectedDataById.baseCategory.name} &nbsp; <Icon name="chevron right" />
                                        {this.props.selectedDataById.category && this.props.selectedDataById.category.name}&nbsp;<Icon name="chevron right" />
                                        {this.props.selectedDataById.subCategory && this.props.selectedDataById.subCategory.name}
                                    </span>}
                                />
                            </Grid.Row>

                            {(this.props.selectedDataById.teamId && this.props.selectedDataById.teamId.toString() !== this.props.selectedOrganisation.id.toString()) ?
                                <Grid.Row >
                                    <Labels
                                        name="Initiative Execution"
                                        text="Team Level" />
                                    <Labels
                                        name="Selected Team"
                                        text={this.getTeam()} />

                                </Grid.Row>
                                :
                                <Grid.Row >
                                    <Grid.Column width={8}>
                                        <Labels
                                            name="Initiative Execution"
                                            text="Workspace Level" />

                                    </Grid.Column>
                                </Grid.Row>
                            }

                            <Grid.Row>
                                <Labels
                                    name="Owner"
                                    text={
                                        <List horizontal >
                                            <List.Item>
                                                <ImageAvater user={this.props.initiativeOwnerDetails} />
                                                <List.Content className='f_12' >
                                                    <EllipsisTooltip
                                                        name={this.props.initiativeOwnerDetails && this.props.initiativeOwnerDetails.firstName + ' ' + this.props.initiativeOwnerDetails.lastName}
                                                        line={2}
                                                        style={{ 'lineHeight': '20px' }}
                                                    />
                                                </List.Content>
                                            </List.Item>
                                        </List>
                                    }
                                />
                            </Grid.Row>
                            {this.props.selectedDataById && this.props.selectedDataById.playbookDesigner ?
                                <Grid.Row>
                                    <Labels
                                        name="Playbook Designer"
                                        text={
                                            <List horizontal >
                                                <List.Item>
                                                    <List.Content className='f_12' >
                                                        <EllipsisTooltip
                                                            name={this.props.selectedDataById && this.props.selectedDataById.playbookDesigner}
                                                            line={2}
                                                        />
                                                    </List.Content>
                                                </List.Item>
                                            </List>
                                        }
                                    />
                                </Grid.Row> : ''}


                            {/* current playbook version  */}
                            {this.props.selectedDataById && this.props.selectedPlaybookData ?
                                <Grid.Row>
                                    <Labels
                                        name="Current Playbook Version"
                                        text={
                                            <List horizontal >
                                                <List.Item>
                                                    <List.Content className='f_12' >
                                                        <EllipsisTooltip
                                                            name={this.props.selectedDataById && this.props.selectedPlaybookData && this.props.selectedPlaybookData.version}
                                                            line={2}
                                                        />
                                                    </List.Content>
                                                </List.Item>
                                            </List>
                                        }
                                    />
                                </Grid.Row> : ''}




                        </Grid.Column >
                        <Grid.Column width={5}>


                            <Card className="organizationCard" >
                                <Card.Content >
                                    <div >
                                        <Loader active={this.state.loader} />
                                        <img src={this.state.updatedImage} className="fitImage" alt="initiative image" />
                                        <Button type="button" className="circular_24_icon first-rectangle-image" icon='pencil' onClick={() => this.openImageModal(true)} />
                                    </div >
                                </Card.Content>
                            </Card>
                            <ImageResizer
                                image={this.state.updatedImage}
                                openImageModal={this.openImageModal}
                                cloudinaryImage={this.cloudinaryImage}
                                open={this.state.open}
                                envData={this.props.envData}
                                width={504}
                                height={280}
                            />


                            <br />
                        </Grid.Column>
                    </Grid.Row>
                </Grid >
            </Form >
        )
    }
}


export default Summary